import { plainText } from "./formatting"

// The checkable lines, in the order they appear on screen: that order is what
// gives Shift+click its meaning. Only the leaves can be checked — moving a
// section into one of its own sub-sections would make no sense.
export const leafOrder = sections => {
  const order = []
  const walk = nodes => (nodes || []).forEach(node => {
    if (node._destroy) return
    if (node.type === "service" || node.type === "descriptive") order.push(node._uid)
    else walk(node.children)
  })
  walk(sections)
  return order
}

// The sections and works that can host lines, with their on-screen number.
//
// Those already carrying sub-sections are left out: `nodeTotals` sums either
// the lines of a node or its sub-sections, never both, so dropping lines there
// would silently drop the sub-section subtotals from the parent total.
export const moveTargets = sections => {
  const targets = []

  // A description carries no number and does not shift its neighbours.
  const walk = (nodes, path) => {
    const numbered = (nodes || []).filter(n => !n._destroy && n.type !== "descriptive")

    numbered.forEach((node, index) => {
      if (node.type !== "group") return

      const code      = [...path, index + 1]
      const children  = (node.children || []).filter(c => !c._destroy)
      const subgroups = children.filter(c => c.type === "group")

      if (subgroups.length === 0) {
        targets.push({
          uid:   node._uid,
          code:  code.join("."),
          label: plainText(node.description) || I18n.t("quotes.builder.selection.untitled"),
        })
      }

      walk(children, code)
    })
  }

  walk(sections, [])
  return targets
}

export const rangeBetween = (order, fromUid, toUid) => {
  const a = order.indexOf(fromUid)
  const b = order.indexOf(toUid)
  if (a === -1 || b === -1) return [toUid]
  return order.slice(Math.min(a, b), Math.max(a, b) + 1)
}
